// extracted by mini-css-extract-plugin
export default {"tasks":"ProtocolDashboardSideBar_tasks__49Mdk","completed":"ProtocolDashboardSideBar_completed__oJ8rj","active":"ProtocolDashboardSideBar_active__2ZDRV"};